// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#facility[data-v-029030c1]{max-width:600px;margin-left:auto;margin-right:auto}#facility .note[data-v-029030c1]{margin:0 20px 20px 0}#facility .facility-image[data-v-029030c1]{border:1px solid #8e8e8e}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
